<template>
  <div class="container faq">
    <div class="row">
      <div class="col-lg-4 mb-30">
        <h3>Ask a question</h3>
        <p>Printing can be complex but we're here to help.</p>
        <a href="mailto:sales@marshallprint.co.uk?subject=Inquiry&body=---%0AContext: FAQ Accordion link"
           class="btn btn-primary mt-4">
          Ask a question
        </a>
      </div>

      <div class="col-lg-8 order-lg-last">
        <div class="details-wrapper">
          <div id="accordion-faq" class="accordion-style-three mb-100">
            <div v-for="item in faqData" :key="item._id" class="accordion-item">
              <div class="accordion-header" :id="'heading-' + item._id">
                <h5 class="mb-0">
                  <button class="btn btn-link accordion-button" type="button" data-bs-toggle="collapse"
                          :data-bs-target="'#collapse-' + item._id" :aria-expanded="item.expanded ? 'true' : 'false'" :aria-controls="'collapse-' + item._id">
                    {{ item.title }}
                  </button>
                </h5>
              </div>
              <div :id="'collapse-' + item._id" class="accordion-collapse collapse" :aria-labelledby="`heading-` + item._id"
                   data-bs-parent="#accordion-faq">
                <div class="accordion-body">
                  <PortableText :value="item.text"/>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- /.details-wrapper -->
      </div>
    </div>
  </div>
</template>

<script>
import { PortableText } from '@portabletext/vue';
  import sanity from "../../../sanity.js";
  export default {
    name: 'faqAccordion',
    components: {PortableText},
    data() {
      return {
        faqData: []
      }
    },
    async created() {
      this.faqData = await sanity.fetch(`*[_type == "faq"]{
        _id,
        title,
        text
      }`);
    }
  }
</script>

<style lang="scss" scoped>
.faq {
  margin: 3rem auto;
  @media (min-width: 500px) {
    margin: 10rem auto 5rem auto;
  }
  h3 {
    font-family: 'gilroy-light', sans-serif;
    font-weight: 100;
    margin: 0 0 0 1.5rem;
  }
  p {
    margin: 0 0 2rem 1.5rem;
  }
  .btn-primary {
    margin: 0 0 0 1.5rem;
  }
  .accordion-style-three {
    .accordion-item {
      border: none;
      box-shadow: 0 0 3rem rgba(0, 0, 0, 0.05);
      margin: 0 0 1rem 0;
      max-width: 40rem;
      padding: 0.5rem;
      @media (min-width: 500px) {
        margin: 0 0 3rem 0;
        padding: 0.5rem 1rem;
      }

      .accordion-header {
        .accordion-button {
          border: none;
          color: var(--darkblue);
          font-family: 'gilroy-light', sans-serif;
          font-size: 1.25rem;
          font-weight: 100;
          padding: 1rem 1rem 1rem 4rem;
          text-decoration: none;
          @media (min-width: 500px) {
            font-size: 1.5rem;
          }

          &:before {
            background-image: url('../../assets/images/logo/cross.svg');
            content: "";
            height: 1rem;
            position: absolute;
            left: 1rem;
            top: 50%;
            transform: translateY(-50%);
            width: 1rem;
          }
          &[aria-expanded="true"]:before {
            background-image: none;
            content: '-';
            font-family: 'gilroy-light', sans-serif;
            font-size: 2.5rem;
            font-weight: 100;
            line-height: 3rem;
            top: 30%;
            transform: translateY(-50%);
          }
        }
      }
      .accordion-body {
        padding: 0 3rem 0 4rem;
      }
    }
  }
}
</style>
